// extracted by mini-css-extract-plugin
module.exports = {"dataIcon":"DataAmount_dataIcon__3HAxa"};